import {createFeatureSelector, Selector} from "@ngrx/store";
import {AppState} from "./app.state";
import {Order} from "./order.state";
import {OrderReviewChecklist} from "./order-review-checklist.state";
import {AllDashboardsFiltersState} from "./all-dashboards-filters.state";

export const orderSelector: Selector<AppState, Order> = createFeatureSelector<Order>('order');
export const dashboardFiltersSelector: Selector<AppState, AllDashboardsFiltersState> = createFeatureSelector<AllDashboardsFiltersState>('dashboardFilters');
export const applicationReviewerChecklistSelector: Selector<AppState, OrderReviewChecklist> = createFeatureSelector<OrderReviewChecklist>('orderReviewChecklist');
